import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Project imports
import useAppFunctionalityConfig from "hooks/useAppFunctionalityConfig";
import { getInternalAppType } from "utils/brandingUtils";
import useAuth from "hooks/useAuth";
import useAppSettings from "hooks/useAppSettings";

const useRouteTracker = () => {
  // --- Hooks --- //
  const location = useLocation();

  const { updateAppContext, mapPagePathToConfigName } = useAppFunctionalityConfig();
  const { userLanguage, trialSubscription } = useAppSettings();
  const { user, userOrg } = useAuth();
  const internalAppType = getInternalAppType({
    pathOrHost: window.location.hostname,
  });

  useEffect(() => {
    // Get subscription type and potentially trial subscription type for context
    const subscriptionType = userOrg?.subscription?.type || "free";
    let trialSubscriptionType = undefined;
    if (subscriptionType === "trial" && trialSubscription) {
      trialSubscriptionType = trialSubscription !== "unknown" ? trialSubscription : undefined;
    }
    // Update app context with current route information on route change
    updateAppContext({
      app: {
        internalAppType,
        subscriptionType,
        trialSubscriptionType,
        countryCode: userOrg?.countryCode || user?.countryCode || undefined,
        language: userLanguage ? userLanguage : undefined,
      },
      route: { pathname: location.pathname, pathId: mapPagePathToConfigName(location.pathname) },
    });
  }, [
    location.pathname,
    userLanguage,
    userOrg,
    user,
    internalAppType,
    trialSubscription,
  ]);
};

export default useRouteTracker;
